import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AvailableFeature, UserProfileService } from '../services/user-profile.service';

/**
 * Render the contents of the element only if the feature is enabled for the user.
 */
@Directive({
    selector: '[appIfFeatureEnabled]',
    standalone: false
})
export class IfFeatureEnabledDirective {
  private feature: AvailableFeature;

  @Input() set appIfFeatureEnabled(feature: AvailableFeature) {
    this.feature = feature;
    this.updateView();
  }

  public constructor(
    private readonly userProfileService: UserProfileService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly templateRef: TemplateRef<unknown>
  ) { }

  private updateView(): void {
    // Hide the element
    this.viewContainerRef.clear();

    // Show the element if the feature is enabled
    if (this.userProfileService.isFeatureEnabled(this.feature)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
